import { Card } from "react-bootstrap";
import "./BarChart.css";

import { DashboardModal } from "../../common";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top" as const,
      display: false,
      labels: {
        font: {
          size: 10,
          family: "Poppins",
          weight: "500",
          lineHeight: 21,
        },
      },
    },
    title: {
      display: false,
      text: "Chart.js Bar Chart",
    },
  },
  layout: {
    padding: 20,
  },
  scales: {
    x: {
      grid: {
        display: false,
        color: "#ffffff",
      },
      beginAtZero: false,
      ticks: {
        color: "#ffffff",
        backdropColor: "#ffffff",
      },
    },
    y: {
      grid: {
        display: false,
        color: "#ffffff",
      },
      beginAtZero: true,
      ticks: {
        color: "#ffffff",
        backdropColor: "#ffffff",
      },
    },
  },
};

const plugins = [
  {
    id: "",
    beforeDraw: function (chart: any) {
      if (chart.chartArea) {
        // console.log("CTX", chart.ctx);
        // console.log("AREA", chart.chartArea);
        // console.log("BAR ARRAY", chart.getDatasetMeta(0).data);
        let barArray: any = chart.getDatasetMeta(0).data;

        for (let i = 0; i < barArray.length; i++) {
          // console.log("BAR Element", barArray[i]);
          // console.log("BAR Element Options", barArray[i].options);

          barArray[i].width = 15;
          barArray[i].options.borderRadius = 20;
          barArray[i].options.borderWidth = 1;
        }
      }
    },
  },
];

const labels = ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"];

export const data = {
  labels,
  datasets: [
    {
      label: "",
      data: labels.map(() => Math.floor(Math.random() * 50)),
      backgroundColor: "#ffffff",
    },
  ],
};

const BarChart = (props: any) => {
  return (
    <>
      <Card className="z-index-2 shadow-sm rounded-3 dashboard-charts">
        <Card.Header className="p-0 position-relative mt-n4 mx-2 z-index-2 bg-transparent border-bottom-0">
          <div
            className={`${
              props.bgClass ? props.bgClass : "bg-danger-fitprenda"
            } shadow-primary border-radius-lg py-3 pe-1`}
          >
                      <Bar options={options} data={(((props.DataValue) && (props.DataValue.length > 0))
                          ? {
                              labels: Array.prototype.map.call(props.DataValue, ((value: any) => value.Name.toString())) || [],
                              datasets: [
                                  {
                                      label: '',
                                      data: Array.prototype.map.call(props.DataValue, ((value: any) => parseInt(value.Value))) || [],
                                      backgroundColor: "#ffffff",
                                  },
                              ],
                          } : {
                              labels: [],
                              datasets: [
                                  {
                                      label: '',
                                      data: [],
                                      backgroundColor: "#ffffff",
                                  },
                              ],
                          }
                      )} plugins={plugins} />
          </div>
        </Card.Header>
        <Card.Body>
          {/* <h6 className="mg-0">WebSite Views</h6> */}
          <p className="text-muted small text-end">{props.title || ""}</p>
          {/* <hr className="dark horizontal"/>

                    <div className="d-flex ">
                        <FontAwesomeIcon icon={"clock"} className="my-auto me-1 text-muted" />
                        <p className="mb-0 text-muted small"> campaign sent 2 days ago </p>
                    </div> */}
        </Card.Body>
      </Card>
    </>
  );
};

export default BarChart;
